<template>
  <div class="locale-changer">
    <v-chip-group
        mandatory
        v-model="localGroup">
      <v-chip small outlined @click="setLocale('de')">🇩🇪</v-chip>
      <v-chip small outlined @click="setLocale('en')">🇺🇸</v-chip>
    </v-chip-group>
  </div>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: 'locale-changer',
  methods: {
    ...mapActions(['fetchSeLocale']),
    setLocale(locale) {
      // console.log('locale', locale)
      this.fetchSeLocale(locale)
      this.$root.$i18n.locale = locale
      this.$vuetify.lang.current = locale
      this.$cookies.set('django_language', locale)
      this.$router.go()
      // console.log('setLocale', this)
    },

  },
  mounted() {
    let language = this.$cookies.get('django_language');
    console.log('locale-changer', language)
    this.$root.$i18n.locale = language
    this.$vuetify.lang.current = language
    if (language === 'de')
      this.localGroup = 0
    else
      this.localGroup = 1
  },
  data() {
    return {
      localGroup: 0
    }
  }
}
</script>

<i18n>
{
  "en": {
    "language": "EN"
  },
  "de": {
    "language": "DE"
  }
}
</i18n>